export enum StatusCode {
	Accepted = 202,
	BadRequest = 400,
	Unauthorized = 401,
	Forbidden = 403,
	NotFound = 404,
}
